import React, {
  useEffect,
  useState,
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

import {
  FaFilePdf,
  FaTimes,
  FaDownload
} from "react-icons/fa";

const MandatoryPublicDisclosure = () => {
  const [open, setOpen] =
    useState(false);

  const [data, setData] =
    useState([]);

  const [viewerOpen, setViewerOpen] =
    useState(false);

  const [selectedPdf, setSelectedPdf] =
    useState("");

  const [selectedTitle, setSelectedTitle] =
    useState("");

  useEffect(() => {
    fetch(
      "https://njinternational.ilakshyaerp.in/api/mpd-documents"
    )
      .then((res) => res.json())
      .then(setData);
  }, []);

  /* DOWNLOAD */
  const handleDownload = async (
    file,
    title
  ) => {
    const url = `https://njinternational.ilakshyaerp.in/uploads/mpd/${file}`;

    const response =
      await fetch(url);

    const blob =
      await response.blob();

    const link =
      document.createElement("a");

    link.href =
      window.URL.createObjectURL(blob);

    link.download =
      title || file;

    document.body.appendChild(
      link
    );

    link.click();
    link.remove();
  };

  /* OPEN PDF */
  const openPdfViewer = (
    file,
    title
  ) => {
    setSelectedPdf(
      `https://njinternational.ilakshyaerp.in/uploads/mpd/${file}`
    );

    setSelectedTitle(title);

    setViewerOpen(true);
  };

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <div className="about-hero">
        <div className="about-overlay">
          <h1>MANDATORY PUBLIC DISCLOSURE</h1>
          <Breadcrumb />
        </div>
      </div>

      <div className="container">

        {/* <h2 className="gallery-title">
          Mandatory Public Disclosure
        </h2> */}

        {/* PDF GRID */}
        <div className="pdf-grid">

          {data.length > 0 ? (
            data.map((d) => (
              <div
                key={d.id}
                className="pdf-card"
              >
                <div
                  className="pdf-card-top"
                  onClick={() =>
                    openPdfViewer(
                      d.file,
                      d.title
                    )
                  }
                >
                  <FaFilePdf className="pdf-icon" />

                  <h3 className="pdf-title">
                    {d.title}
                  </h3>
                </div>

                <button
                  className="pdf-btn"
                  onClick={() =>
                    handleDownload(
                      d.file,
                      d.title
                    )
                  }
                >
                  Download
                </button>
              </div>
            ))
          ) : (
            <div className="life-empty">
              <h3>No Documents</h3>
              <br />
              Files will be uploaded soon.
            </div>
          )}

        </div>

      </div>

      {/* PDF VIEWER */}
      {viewerOpen && (
        <div className="drive-viewer">

          <div className="drive-topbar">

            <div className="drive-left-top">
              <FaFilePdf />
              <span>
                {selectedTitle}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                gap: "15px",
                alignItems:
                  "center",
              }}
            >
              <button
                className="pdf-btn"
                onClick={() =>
                  handleDownload(
                    selectedPdf
                      .split("/")
                      .pop(),
                    selectedTitle
                  )
                }
              >
                <FaDownload />{" "}
                Download
              </button>

              <button
                className="drive-close"
                onClick={() =>
                  setViewerOpen(
                    false
                  )
                }
              >
                <FaTimes />
              </button>

            </div>

          </div>

          <div
            style={{
              flex: 1,
              background:
                "#111",
            }}
          >
            <iframe
              src={selectedPdf}
              title="pdf"
              width="100%"
              height="100%"
              style={{
                border:
                  "none",
              }}
            />
          </div>

        </div>
      )}

      <Footer />
    </>
  );
};

export default MandatoryPublicDisclosure;